module.exports = __webpack_public_path__ + "static/media/plainMountain.626d42bf.JPG";